import type { z } from "zod";

import { avatarSchema } from "./avatarSchema";

export const avatarsSchema = avatarSchema.array();

export type AvatarsSchema = z.infer<typeof avatarsSchema>;
